import styled from "styled-components";
import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import { useAppContext } from "../Context/Context";
import { useSelector } from "react-redux";

const sidebarConfig = [
  {
    id: 1,
  
    link: "/listener/dashboard",
    title: "Overview",
  },

  {
    id: 2,
    
    link: "/listener/events",
    title: "Events",
  },

  {
    id: 3,
   
    link: "/listener/settings",
    title: "Settings",
  },

  // {
  //   id: 7,
   
  //   link: "/users/test",
  //   title: "Test",
  // },
];

export default function ListenerSidebar() {
  const [activeTab, setActiveTab] = useState("Dashboard");
  const { isSidebarOpen, setIsSidebarOpen, setIsProfileOpen } = useAppContext();
  const navigate = useNavigate()

  function handleNavClick(title) {
    setActiveTab(title);
    setIsSidebarOpen(false);
    setIsProfileOpen(false);
  }
 
  const {openSideBar} = useSelector((state)=> state.app)

  return (
    <SIDEBAR  className={ openSideBar ? "open" : "close"}>
      <div 
        className={`containers ${
          isSidebarOpen ? "opened" : "closed"
        }`}
      >
        <div className="nav-container ">
            
          <div className="wrapper ">
            <div className="nav-links ">
              {sidebarConfig.map(({ link, title }, index) => (
                <Link
                  className={`nav-link react-router-link ${
                    activeTab === title ? "active-tab" : ""
                  }`}
                  to={link}
                  key={index}
                  onClick={() => handleNavClick(title)}
                >
                
                  {title}
                </Link>
              ))}
            </div>
          </div>
          
          <div className="help-center">

          </div>
        </div>
        <Closer
          style={{display: "flex"}}
          onClick={() => {
            setIsSidebarOpen(false);
          }}
        ></Closer>
      </div>
    </SIDEBAR>
  );
}
const SIDEBAR = styled.div`

  
  height: auto !important;
  padding-top: 40px;
  width: 15%;
  
  

  .containers {
    display: flex;
    flex-direction: row;
    width: 15%;
    padding-left: 20px;

    align-items: center;
    position: fixed;
    top: 0px;
    padding-top: 50px;
    padding-right: 0 !important;
  }
  .nav-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 100px;
    align-items: center;
  padding-top: 30px;

  }
  .wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    

    width: 100%;
    align-items: center;
    padding-right: 0 !important;
  }
  .nav-links {
    display: flex;
    flex-direction: column;
    
    gap: 20px;
    width: 100% !important;
  }
  .help-center {
    width: 188px;
    height: 212px;
  }
  .help-center img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .nav-link {
    font-weight: 500 !important;
    color: #818893 !important;
    display: flex;
    font-size: 14px !important;
    justify-content: left !important;
    text-decoration: none !important;
    gap: 15px;
    align-items: center;
    &:hover {
    font-weight: 600 !important;
    color: #060B13 !important;
      transition: 0.3s;
    }
  }
  .active-tab {
    font-weight: 600 !important;
    color: #060B13  !important;
    border-right: 3px solid #000000
  }
  
  @media screen and (max-width: 1100px) {
   
    .container {
      background: white;
    }
    /* .closed {
      margin-left: -1000px;
      transition: 0.3s;
    } */
    /* .opened {
      width: 250px;
      margin-left: 0;
      transition: 0.3s;
      display: flex;
      position: fixed !important;
      z-index: 2;
    } */
  }

    /* margin-top: 45px !important; */
    @media (max-width: 1120px) {
    
 height: 100vh;
 position: fixed;
 .containers { 
   background: #ffffff;
   margin-top: 70px;
   width: 300px;
 }
}
@media (max-width: 992px) {
  .containers {
  margin-top: 135px;
  }
}
@media screen and (max-width: 630px) { 
  .containers {
  margin-top: 185px;
  }
}
@media screen and (max-width: 475px) { 
  .containers {
  margin-top: 210px;
  }
}
@media screen and (max-width: 435px) { 
  .containers {
  margin-top: 270px;
  }
}
@media screen and (max-width: 340px) { 
  .containers {
  margin-top: 293px;
  }
}
  @media screen and (max-width: 678px) {
    .container {
      padding-right: 0 !important;
      padding-left: 0 !important;

      background-color: transparent;
    }
    .opened {
      width: 100%;
    }
    .nav-container {
      width: 250px;
      background-color: white;
    }
  }
`;
const Closer = styled.div`
  display: none;
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(4px);
  z-index: 9999;
  @media screen and (max-width: 500px) {
    display: flex;
    height: 100%;
    width: calc(100vw - 250px);
  }
`;
